import React, { useEffect, useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'

import { fetchAdminPaymentChartMonthly, fetchAdminPaymentChartDaily } from '../../actions/adminActions'

export const PaymentCharts = () => {
  const dispatch = useDispatch()
  const paymentChartMonthly = useSelector(store => store.admin.paymentChartMonthly)
  const paymentChartDaily = useSelector(store => store.admin.paymentChartDaily)

  useEffect(() => {
    dispatch(fetchAdminPaymentChartMonthly())
    dispatch(fetchAdminPaymentChartDaily())
  }, [])

  const maxMonth = useMemo(() => Math.max(...paymentChartMonthly.map(obj => parseInt(obj.total))), [
    paymentChartMonthly
  ])

  const height = useCallback(value => (value / maxMonth) * 98, [maxMonth])

  const maxMonthDaily = useMemo(() => Math.max(...paymentChartDaily.map(obj => parseInt(obj.total))), [
    paymentChartDaily
  ])

  const widthDaily = useCallback(value => (value / maxMonthDaily) * 98, [maxMonthDaily])

  return (
    <div>
      <div className="text-4xl">Monthly</div>
      <div className="lg:w-1/2">
        {paymentChartMonthly.map(obj => (
          <div className="flex h-8 border-b-2 border-orange-100 items-center" key={obj.date}>
            <div className="flex-none w-20 text-sm font-semibold text-gray-600">
              {dayjs(obj.date).format('MM-YYYY')}
            </div>
            <div className="flex-none w-16 text-sm font-semibold text-gray-600">${parseInt(obj.total)}</div>
            <div className="flex-grow self-stretch bg-orange-100">
              <div className="h-full bg-orange-500" style={{ width: `${height(obj.total)}%` }}></div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-4xl mt-16">Daily</div>
      <div className="lg:w-1/2">
        {paymentChartDaily.map(obj => (
          <div className="flex h-8 border-b-2 border-orange-100 items-center" key={obj.date}>
            <div className="flex-none w-20 text-sm font-semibold text-gray-600">{dayjs(obj.date).format('MM-DD')}</div>
            <div className="flex-none w-16 text-sm font-semibold text-gray-600">${parseInt(obj.total)}</div>
            <div className="flex-grow self-stretch bg-orange-100">
              <div className="h-full bg-orange-500" style={{ width: `${widthDaily(obj.total)}%` }}></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PaymentCharts
